<template>
  <div style="position: relative">
    <!--  这个div里面开始写  -->
    <div class="head">
      <div class="littelhead">
        <img v-if="this.login.name!==null" :src="this.login.headPortrait" width="30px" height="30px">
        <i v-if="this.login.islogin===null" class="el-icon-user-solid" style="font-size: 30px;"></i>

        <b style="border-bottom: 50px">{{ this.login.name !== null ? this.login.name : "用户" }}</b>
        <div style="margin: 20px 0;"></div>
        <div style="margin-left: 10px;margin-right: 10px;">

          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="content">
              <el-input style="color: red"
                        type="textarea"
                        :rows="5"
                        placeholder="请输入你的留言"
                        v-model="ruleForm.checkText">
              </el-input>
            </el-form-item>


            <div style="margin: 20px 0;"></div>
            <el-form-item style="text-align: right">
              <el-button @click="send('ruleForm')" type="primary">点击发表</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="fewbody">
        <div v-for="item of user">
          <div style="display: flex;height: 30px">
            <img :src="item.user[0]&&item.user[0].headPortrait" width="30px" height="30px">
            <div style="display: flex;line-height: 30px;margin-left: 10px">{{ item.user[0].name }}</div>&nbsp;&nbsp;&nbsp;
            <div style="display: flex;line-height: 30px"><font style="color: gray;font-size: 5px">{{
                item.createTime
              }}</font>
            </div>
          </div>

          <div style="margin-left: 25px;width: 850px">
            <p>{{ item.content }}</p>


            <!--是否有回复 -->
            <div v-if="item.isReply===1">
              <div style="display: flex;height: 30px" v-if="item.admin[0]">
                <img :src="item.admin[0]&&item.admin[0].headPortraitUrl" width="30px" height="30px">
                <div style="display: flex;line-height: 30px;margin-left: 10px;">{{ item.admin[0].adminName }}(作者)</div>&nbsp;&nbsp;&nbsp;
                <div style="display: flex;line-height: 30px"><font
                  style="color: gray;font-size: 5px">{{ item.updateTime }}</font></div>
              </div>

              <p style="margin-left: 30px"> {{ item.replyContent }}</p>
            </div>
            <div v-else></div>
            <el-divider></el-divider>
          </div>
        </div>


      </div>
    </div>

    <div class="body">
      <div class="fewbody" style="background-color: transparent;border: none;margin-bottom: 30px">
        <el-pagination @current-change="currentChange" style="text-align: left"
                       background
                       layout="prev, pager, next"
                       :total="page.count">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import request from "../utils/axiosUtils";
import base_url from "../utils/Constants";

export default {
  name: "leaveMsg",
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.ruleForm.checkText === "") {
        callback(new Error('留言内容不能为空！'));
      } else if (this.ruleForm.checkText.length > 100) {
        return callback(new Error('留言内容不超过100字！'))
      } else {
        if (this.ruleForm.checkText !== '') {
          this.$refs.ruleForm.validateField('checkText');
        }
        callback();
      }
    };
    return {
      textarea: '',
      login: {
        name: null,
        headPortrait: null,
        islogin: null,
        id: null,
        userId: null,
      },
      page: {
        currentPage: 0,
        count: null,
      },
      user: [
        {
          admin: [
            {
              headPortraitUrl: null,
              adminName: null,
            }
          ],
          createTime: null,
          content: '',
          isReply: null,
          replyContent: null,
          updateTime: null,
          user: [{
            headPortrait: null,
            name: null,
          }],
        },
      ],
      author: [
        {}
      ],
      ruleForm: {
        checkText: ''
      },
      rules: {
        content: [
          {validator: validatePass, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    getMes() {//获取留言信息总数据
      let that = this;
      request({
        url: "/Leave",
        method: 'get',
        params: {
          page: that.page.currentPage
        }
      }).then(response => {
        let data = response.data.data;
        for (let i = 0; i < data.length; i++) {
          if(data[i].user[0]){
            data[i].user[0].headPortrait = base_url + '/getImage/' + data[i].user[0].headPortrait;
          }
          if (data[i].isReply === 1) {
            if(data[i].admin[0]){
              data[i].admin[0].headPortraitUrl = base_url + '/getImage/' + data[i].admin[0].headPortraitUrl;
            }
          }
          data[i].createTime = that.handTime(response.data.data[i].createTime);
          data[i].updateTime = that.handTime(response.data.data[i].updateTime);
        }
        that.user = data;
        that.getCount();
      });
    }, getCount() {//获取总数据条数
      let that = this;
      request({
        url: "/Leave/count",
        method: 'get',
      }).then(response => {
        let num1 = Math.floor(response.data / 5);
        if (response.data % 5 !== 0) {
          num1++;
        }
        that.page.count = num1 * 10;
      });
    },

    handTime(data) {//处理时间 以多少天之前、多少秒之前...展示
      let currentTime = new Date().getTime();
      let recentTime = new Date(
        data.substr(0, 4),
        parseInt(data.substr(5, 2)) - 1,
        data.substr(8, 2),
        data.substr(11, 2),
        data.substr(14, 2),
        data.substr(17, 2),
      ).getTime();

      let time = currentTime - recentTime;
      let seconds = parseInt(time / 1000 + "");//秒
      let targetTime = null;
      if (seconds >= 60 * 60 * 24 * 30 * 12) {//31,104,000
        targetTime = parseInt(seconds / (60 * 60 * 24 * 30 * 12)) + "年前";
      } else if (seconds >= 60 * 60 * 24 * 30) {//2,592,000
        targetTime = parseInt(seconds / (60 * 60 * 24 * 30)) + "月前";
      } else if (seconds >= 60 * 60 * 24) {//86,400
        targetTime = parseInt(seconds / (60 * 60 * 24)) + "天前";
      } else if (seconds >= 60 * 60) {//3,600
        targetTime = parseInt(seconds / (60 * 60)) + "小时前";
      } else if (seconds >= 60) {//60
        targetTime = parseInt(seconds / 60) + "分前";
      } else {
        targetTime = seconds + "秒前";
      }
      return targetTime;
    },
    send(formName) {//实现发表留言内容
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.login.name !== null) {
            let that = this;
            request({
              url: '/Leave/leaveMsg',
              method: 'post',
              params: {
                userId: that.login.userId,
                content: that.ruleForm.checkText
              }
            }).then(response => {
              if (response.data.flag) {
                that.getMes();
                this.$message({
                  type: 'success',
                  message: '留言成功'
                });
                that.editDialogVisible = false;
              } else {
                this.$notify.error({
                  title: '回复',
                  duration: 4000,
                  message: '留言失败'
                });
              }
            })
          } else {
            this.$message({
              type: 'error',
              message: '请先登陆'
            });
          }
        }
      })
    },
    currentChange(value) {//实现翻页效果
      this.page.currentPage = (value - 1) * 5;
      console.log((value - 1) * 5, this.getMes())
    }
  },
  mounted() {//获取初始数据
    this.getMes();
    let user = window.localStorage.getItem("name");
    if (user !== null) {
      this.login.islogin = window.localStorage.getItem("isLogin");
      this.login.name = window.localStorage.getItem("name");
      this.login.userId = window.localStorage.getItem("userId");
      this.login.headPortrait = base_url + '/getImage/' + window.localStorage.getItem("headPortrait");
    }
  }
}
</script>
<style>
.head .el-textarea textarea {
  background-color: rgba(255, 255, 255, 0.1);
  color: rgb(0, 0, 0);
  font-weight: 600;
  letter-spacing: 1px;
}

.head .el-textarea textarea::placeholder {
  color: gray;
}

</style>
<style scoped>
.head {
  margin-top: 20px;
  width: 100%;
  height: max-content;
  align-items: center;
}

.body {
  margin-top: 20px;
  width: 100%;
  height: max-content;
  align-items: center;
}

.littelhead {
  padding-top: 20px;
  padding-left: 20px;
  border: 1px solid white;
  width: 900px;
  height: 270px;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.7);
}

.fewbody {
  padding-top: 20px;
  padding-left: 20px;
  border: 1px solid white;
  width: 900px;
  height: max-content;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/leaveMsg.vue